const mapCategories = (items) => {
    const res = {};

    if (items && items.length > 0) {
        for (let i = 0, il = items.length; i < il; ++i) {
            res[items[i].id] = items[i].title;
        }
    }

    return res;
};

const mapNestedCategories = (items) => {
    const res = {};

    if (items && items.length > 0) {
        for (let i = 0, il = items.length; i < il; ++i) {
            res[items[i].id] = {
                title: items[i].title,
                children: mapNestedCategories(items[i].children),
            };
        }
    }

    return res;
};

const mapCategoryIds = (items) => {
    const res = [];

    if (items && items.length > 0) {
        for (let i = 0, il = items.length; i < il; ++i) {
            res.push(items[i].id);
        }
    }

    return res;
};

export { mapCategories, mapCategoryIds, mapNestedCategories };
